import axios from 'axios'

const CMS_API_BASE = process.env.CMS_API_BASE

type Response = {
  price: string
}

export default async function fetchSeminarPrice(id: string) {
  const response = await axios.get<Response>(
    `${CMS_API_BASE}/seminars/${id}/price`,
  )

  return response.data.price
}
